import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

function AboutList() {
  const [productLists, setProductListt] = useState([]);

  useEffect(() => {
    productList();

    return () => {};
  }, []);

  const productList = async () => {
    try {
      const getToken = localStorage.getItem("authToken");

      const response = await fetch("http://localhost:3022/users/aboutList", {
        method: "GET",
        headers: {
          "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
          Authorization: `Bearer ${getToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json(); // Response ko JSON me convert kare

        setProductListt(data?.about);
        console.log("User data:", data);
      } else {
        console.log("error:");
        // Login failed
        // setError(data.message || "Login failed");
      }
    } catch (err) {
      // setError("Something went wrong. Please try again.");
    }
  };

  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [productId, setproductId] = useState("");
  const [productDetails, setproductDetails] = useState({});

  const onChange = (e) => {
    setproductDetails({ ...productDetails, [e.target.name]: e.target.value });
  };

  const handleClose = () => setShow(false);
  const handleClosedelete = () => setShowDelete(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShow = () => setShow(true);

  const hendleToDeleteShow = (id) => {
    setproductId(id);
    setShowDelete(true);
  };
  const hendleToEditShow = (id) => {
    setproductDetails(id);
    setShowEdit(true);
  };

  const hendleTocompletedetele = async () => {
    try {
      const getToken = localStorage.getItem("authToken");

      const response = await fetch(
        "http://localhost:3022/users/aboutDelete/" + productId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
            Authorization: `Bearer ${getToken}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json(); // Response ko JSON me convert kare
        productList();
        setShowDelete(false);
        // setProductListt(data?.user);
        console.log("User data:", data);
      } else {
        console.log("error:");
        // Login failed
        // setError(data.message || "Login failed");
      }
    } catch (err) {
      // setError("Something went wrong. Please try again.");
    }
  };
  const hendleTocompleteEdit = async () => {
    try {
      const getToken = localStorage.getItem("authToken");

      const response = await fetch(
        "http://localhost:3022/users/aboutUpdate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
            Authorization: `Bearer ${getToken}`,
          },
          body: JSON.stringify(productDetails),
        }
      );

      if (response.ok) {
        const data = await response.json(); // Response ko JSON me convert kare
        productList();
        setShowEdit(false);
        // setProductListt(data?.user);
        console.log("User data:", data);
      } else {
        console.log("error:");
        // Login failed
        // setError(data.message || "Login failed");
      }
    } catch (err) {
      // setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div>
      <Link to={"/add-about"}>Add slider</Link>
      <Link to={"/"}>Home</Link>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDelete} onHide={handleClosedelete}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this product</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosedelete}>
            Close
          </Button>
          <Button variant="primary" onClick={hendleTocompletedetele}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showEdit} onHide={handleCloseEdit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            className="form-control mt-3"
            type="text"
            name="title"
            onChange={onChange}
            value={productDetails?.name}
            placeholder="title"
          />
          <input
            className="form-control  mt-3"
            type="text"
            name="description"
            onChange={onChange}
            value={productDetails?.price}
            placeholder="description"
          />
           <input
            className="form-control  mt-3"
            type="text"
            name="featureImage"
            onChange={onChange}
            value={productDetails?.featureImage}
            placeholder="featureImage"
          />
          <input
            className="form-control  mt-3"
            type="text"
            name="buttonText"
            onChange={onChange}
            value={productDetails?.size}
            placeholder="buttonText"
          />
          <input
            className="form-control  mt-3"
            type="text"
            name="buttonLink"
            onChange={onChange}
            value={productDetails?.color}
            placeholder="buttonLink"
          />
             <input
            className="form-control  mt-3"
            type="text"
            name="featureTitle"
            onChange={onChange}
            value={productDetails?.size}
            placeholder="featureTitle"  
          />
          <input
            className="form-control  mt-3"
            type="text"
            name="featureDescription"
            onChange={onChange}
            value={productDetails?.color}
            placeholder="featureDescription"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosedelete}>
            Close
          </Button>
          <Button variant="primary" onClick={hendleTocompleteEdit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}

      {/* {
                productLists && productLists?.map((item, index) => {
                    return (
                        <div key={index}>
                            <div>{item?.name}</div>
                            <div>{item?.category}</div>
                            <div>{item?.price}</div>
                            <button class="btn btn-danger" >Delete</button>
                            <button class="btn btn-primary">edit</button>


                        </div>
  

                    )
                })
            } */}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>featureImage</th>
          
            <th>description</th>
            <th>title</th>
            <th>buttonText</th>


            <th>buttonLink</th>
            
            <th>featureTitle</th>
            <th>featureDescription</th>
          </tr>
        </thead>
        <tbody>
          {productLists &&
            productLists?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
  <img
    src={`http://localhost:3022${item?.featureImage}`} // Update the base URL accordingly
    alt="Feature"
    style={{ width: "100px", height: "auto" }}
  />
</td>
                  <td>{item?.title}</td>
                  <td>{item?.description}</td>
                  <td>{item?.buttonText}</td>
                  <td>{item?.buttonLink}</td>
                  <td>{item?.featureTitle}</td>
                  <td>{item?.featureDescription}</td>

                  <td>
                    <button
                      class="btn btn-danger"
                      onClick={() => hendleToDeleteShow(item?._id)}
                    >
                      Delete
                    </button>
                    <button
                      class="btn btn-primary"
                      onClick={() => hendleToEditShow(item)}
                    >
                      edit
                    </button>{" "}
                  </td>
                </tr>
              );
            })}
          {/* <tr>
          <td>1</td>
          <td>Mark</td>
          <td>Otto</td>
          <td>@mdo</td>
          <td>Mark</td>
          <td>Otto</td>
         
        </tr> */}
        </tbody>
      </Table>
    </div>
  );
}

export default AboutList;


